import * as moment from 'moment';
import demData from '../../../data/early_voting_data_dem.json';
import repData from '../../../data/early_voting_data_rep.json';
import countyHistorical from '../../../data/counties.json';

// 11 days of early voting in 2020
let earlyVotingLength = 11;

// get the latest dem date
let momentDemDates = Object.keys(demData).map(d => moment(d)),
  maxDemDate = moment.max(momentDemDates);

// the latest cumulative dem data
let latestDemData = demData[maxDemDate.format('YYYY-MM-DD HH:mm:ss.S')],
  latestCumulativeDemVotes =
    latestDemData.county_results['TOTAL'][
      'cumulative_votes_in_person_and_mail'
    ];

// get the latest rep date
let momentRepDates = Object.keys(repData).map(d => moment(d)),
  maxRepDate = moment.max(momentRepDates);

// the latest cumulative rep data
let latestRepData = repData[maxRepDate.format('YYYY-MM-DD HH:mm:ss.S')],
  latestCumulativeRepVotes =
    latestRepData.county_results['TOTAL'][
      'cumulative_votes_in_person_and_mail'
    ];

// registered voters across parties
// reg voters is listed as same number for dem and rep data
let totalRegVoters = parseFloat(
  latestDemData.county_results['TOTAL']['registered_voters'].replace(/,/g, '')
);

// cumulative registered votes across parties
let totalCumulativeVotes =
  parseFloat(latestCumulativeDemVotes.replace(/,/g, '')) +
  parseFloat(latestCumulativeRepVotes.replace(/,/g, ''));

// first day of early voting + how many days of results we have
let firstDayEarlyVoting = moment.min(momentDemDates),
  numberOfDaysResults = maxDemDate.diff(firstDayEarlyVoting, 'days') + 1;

// get the top 10 counties
// DON'T INCLUDE TOTAL
let top10Counties2020 = Object.keys(latestDemData.county_results).slice(0, 10);

// get the top 10's latest dem data (as of day _)
let top10Dem2020 = top10Counties2020.map(c => latestDemData.county_results[c]),
  top10CumulativeDemVotes2020 = top10Dem2020 // get the total votes from the top 10 counties
    .map(d =>
      parseFloat(d.cumulative_votes_in_person_and_mail.replace(/,/g, ''))
    )
    .reduce((a, b) => a + b, 0);

// get the top 10's latest rep data (as of day _)
let top10Rep2020 = top10Counties2020.map(c => latestRepData.county_results[c]),
  top10CumulativeRepVotes2020 = top10Rep2020 // get the total votes from the top 10 counties
    .map(d =>
      parseFloat(d.cumulative_votes_in_person_and_mail.replace(/,/g, ''))
    )
    .reduce((a, b) => a + b, 0);

// add top 10 dem and top 10 rep together
let top10CumulativeVotes2020 =
  top10CumulativeDemVotes2020 + top10CumulativeRepVotes2020;

// get top 10's historical data
let top10Historical = countyHistorical[
  `day_${numberOfDaysResults}_historical`
].filter(c => top10Counties2020.includes(c.name.toUpperCase()));

// get top 10's 2016 and 2012 dem data
let top10HistoricalDem2016 = sumTop10Historical(2016, 'dem'),
  top10HistoricalRep2016 = sumTop10Historical(2016, 'rep');

let top10HistoricalDem2012 = sumTop10Historical(2012, 'dem'),
  top10HistoricalRep2012 = sumTop10Historical(2012, 'rep');

// party needs to be dem or rep
function sumTop10Historical(year, party) {
  return top10Historical.reduce((a, b) => {
    if (
      !b[`${year}_cumulative_votes_${party}`] ||
      b[`${year}_cumulative_votes_${party}`] == ''
    ) {
      return a + 0;
    } else {
      return a + b[`${year}_cumulative_votes_${party}`];
    }
  }, 0);
}

let top10CumulativeVotes2016 = top10HistoricalDem2016 + top10HistoricalRep2016,
  top10CumulativeVotes2012 = top10HistoricalDem2012 + top10HistoricalRep2012;

export {
  earlyVotingLength,
  maxDemDate,
  latestCumulativeDemVotes,
  latestCumulativeRepVotes,
  totalCumulativeVotes,
  totalRegVoters,
  numberOfDaysResults,
  firstDayEarlyVoting,
  top10Counties2020,
  top10CumulativeVotes2020,
  top10CumulativeVotes2016,
  top10CumulativeVotes2012,
};
